<template>
  <div style="overflow: hidden;height:100%">
    <!-- <div class="jurisdictionItem">
			<div class="jurisdictionTitle">系统权限</div>
			<multipleSelection ref="pcmSelection" :dataList="pcmRightList" style="height: 320px;" :selectionType="selectionType" :getIdMethod="item => item.id"></multipleSelection>
		</div> -->
    <div class="jurisdictionItem">
      <div class="jurisdictionTitle">WEB权限</div>
      <multipleSelection ref="menuSelection" :dataList="menuRightList" style="height: calc(100% - 45px);"
        :selectionType="selectionType" :getIdMethod="item => item.id"></multipleSelection>
    </div>
    <div class="jurisdictionItem">
      <div class="jurisdictionTitle">APP权限</div>
      <multipleSelection ref="appSelection" :dataList="appRightList" style="height: calc(100% - 45px);"
        :selectionType="selectionType" :getIdMethod="item => item.id"></multipleSelection>
    </div>
    <div class="jurisdictionItem">
      <div class="jurisdictionTitle">MINI权限</div>
      <!-- :recurList='recurMiniRightList' -->
      <multipleSelection ref="miniSelection" :dataList="miniRightList" style="height: calc(100% - 45px);"
        :selectionType="selectionType" :getIdMethod="item => item.id"></multipleSelection>
    </div>
  </div>
</template>

<script>
  import multipleSelection from '@/components/module/selection/base/multipleSelection.vue'
  import MenuMultipleSelection from '@/components/module/selection/base/MenuMultipleSelection.vue'
  import userManagerStore from '@/page/userManager/userManagerStore.js'
  export default {
    components: {
      multipleSelection,
      MenuMultipleSelection
    },
    props: {

    },
    data () {
      return {
        selectionType: 'multiple',

        recurMiniRightList: [], //转化后
      }
    },
    created () {

    },
    mounted () {
      this.coverCheckedIds()

    },
    destroyed () {

    },
    computed: {
      user () {
        return userManagerStore.state.nowUser
      },
      unit () {
        return userManagerStore.state.nowUnit
      },
      allRightList () {
        return userManagerStore.state.allRightDatas
      },
      menuRightList () {
        var d=[
          {
            "next": [],
            "rightname": "系统概况",
            "visible": 1,
            "formclass": null,
            "iconFile": "",
            "memo": "",
            "rightcode": null,
            "showdialog": null,
            "pagePath": null,
            "title": null,
            "parentid": "",
            "serialno": 1,
            "righttype": "menuright",
            "library": null,
            "createTime": 1709866858000,
            "enable": 1,
            "entityName": "PcmRight",
            "pageFile": null,
            "rightid": "4a18666e08b14259919343a4f0ddab63",
            "hasSonMenu": 0,
            "id": "4a18666e08b14259919343a4f0ddab63",
            "webiconcssclass": null,
            "webpage": "/distributing",
            "isPage": null,
            "name": "系统概况"
          },
          {
            "next": [
              {
                "next": [],
                "rightname": "配电房->获取系统设备运行总览",
                "visible": 1,
                "formclass": null,
                "iconFile": null,
                "memo": null,
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "6013db6db0b14ecca8525552e33a01a7",
                "serialno": 127,
                "righttype": "menuright",
                "library": null,
                "createTime": null,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "6746fdbf41354c8fa884f3cfc28145ba",
                "hasSonMenu": 0,
                "id": "6746fdbf41354c8fa884f3cfc28145ba",
                "webiconcssclass": null,
                "webpage": "/homePage/body",
                "isPage": 0,
                "name": "配电房->获取系统设备运行总览"
              }
            ],
            "rightname": "配电房系统首页",
            "visible": 1,
            "formclass": null,
            "iconFile": null,
            "memo": null,
            "rightcode": null,
            "showdialog": null,
            "pagePath": null,
            "title": null,
            "parentid": null,
            "serialno": 1,
            "righttype": "menuright",
            "library": null,
            "createTime": null,
            "enable": 1,
            "entityName": "PcmRight",
            "pageFile": null,
            "rightid": "6013db6db0b14ecca8525552e33a01a7",
            "hasSonMenu": 1,
            "id": "6013db6db0b14ecca8525552e33a01a7",
            "webiconcssclass": null,
            "webpage": null,
            "isPage": 0,
            "name": "配电房系统首页"
          },
          {
            "next": [],
            "rightname": "自定义看板",
            "visible": 1,
            "formclass": null,
            "iconFile": null,
            "memo": null,
            "rightcode": null,
            "showdialog": null,
            "pagePath": null,
            "title": null,
            "parentid": null,
            "serialno": 1,
            "righttype": "menuright",
            "library": null,
            "createTime": null,
            "enable": 1,
            "entityName": "PcmRight",
            "pageFile": null,
            "rightid": "92717f66727d4ad1be5d8b614158362e",
            "hasSonMenu": 0,
            "id": "92717f66727d4ad1be5d8b614158362e",
            "webiconcssclass": null,
            "webpage": "/customKanBan",
            "isPage": 0,
            "name": "自定义看板"
          },
          {
            "next": [],
            "rightname": "数据对比",
            "visible": 1,
            "formclass": null,
            "iconFile": null,
            "memo": null,
            "rightcode": null,
            "showdialog": null,
            "pagePath": null,
            "title": null,
            "parentid": null,
            "serialno": 1,
            "righttype": "menuright",
            "library": null,
            "createTime": null,
            "enable": 1,
            "entityName": "PcmRight",
            "pageFile": null,
            "rightid": "fd4c3379293f42eebc777986b5ae974c",
            "hasSonMenu": 0,
            "id": "fd4c3379293f42eebc777986b5ae974c",
            "webiconcssclass": null,
            "webpage": "/dataComparison",
            "isPage": 0,
            "name": "数据对比"
          }];
        return d
      },
      appRightList () {
        var d=[
          {
            "next": [
              {
                "next": [],
                "rightname": "欢迎页面",
                "visible": 1,
                "formclass": null,
                "iconFile": null,
                "memo": null,
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "97BF612A3A574FCAA64A8399398A0DBE",
                "serialno": 1,
                "righttype": "appright",
                "library": null,
                "createTime": null,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "98c4ec1a48b64b53a663d1c744965a58",
                "hasSonMenu": 0,
                "id": "98c4ec1a48b64b53a663d1c744965a58",
                "webiconcssclass": null,
                "webpage": "/systemInitialize",
                "isPage": 0,
                "name": "欢迎页面"
              },
              {
                "next": [
                  {
                    "next": [],
                    "rightname": "实时曲线",
                    "visible": 1,
                    "formclass": null,
                    "iconFile": "/realcurve.png;/",
                    "memo": null,
                    "rightcode": null,
                    "showdialog": null,
                    "pagePath": null,
                    "title": null,
                    "parentid": "F7A4549B82914D97AA334E6572F3F171",
                    "serialno": 2,
                    "righttype": "appright",
                    "library": null,
                    "createTime": null,
                    "enable": 1,
                    "entityName": "PcmRight",
                    "pageFile": null,
                    "rightid": "20cd854121444d6dbf6ee0cb08450954",
                    "hasSonMenu": 0,
                    "id": "20cd854121444d6dbf6ee0cb08450954",
                    "webiconcssclass": null,
                    "webpage": "/virtualDeviceRTCurve",
                    "isPage": 0,
                    "name": "实时曲线"
                  },
                  {
                    "next": [],
                    "rightname": "实时列表",
                    "visible": 1,
                    "formclass": null,
                    "iconFile": "/pushinfoList.png;/",
                    "memo": null,
                    "rightcode": null,
                    "showdialog": null,
                    "pagePath": null,
                    "title": null,
                    "parentid": "F7A4549B82914D97AA334E6572F3F171",
                    "serialno": 3,
                    "righttype": "appright",
                    "library": null,
                    "createTime": null,
                    "enable": 1,
                    "entityName": "PcmRight",
                    "pageFile": null,
                    "rightid": "84e68e47cdf144ffbf27327c788f97a9",
                    "hasSonMenu": 0,
                    "id": "84e68e47cdf144ffbf27327c788f97a9",
                    "webiconcssclass": null,
                    "webpage": "/virtualDeviceRTValue",
                    "isPage": 0,
                    "name": "实时列表"
                  },
                  {
                    "next": [],
                    "rightname": "接线图",
                    "visible": 1,
                    "formclass": null,
                    "iconFile": "/svg.png;/",
                    "memo": null,
                    "rightcode": null,
                    "showdialog": null,
                    "pagePath": null,
                    "title": null,
                    "parentid": "F7A4549B82914D97AA334E6572F3F171",
                    "serialno": 4,
                    "righttype": "appright",
                    "library": null,
                    "createTime": null,
                    "enable": 1,
                    "entityName": "PcmRight",
                    "pageFile": null,
                    "rightid": "ab879b73ed8f401e97ba43436e9ebb63",
                    "hasSonMenu": 0,
                    "id": "ab879b73ed8f401e97ba43436e9ebb63",
                    "webiconcssclass": null,
                    "webpage": "/svgList",
                    "isPage": 0,
                    "name": "接线图"
                  },
                  {
                    "next": [],
                    "rightname": "告警信息",
                    "visible": 1,
                    "formclass": null,
                    "iconFile": "/events.png;/",
                    "memo": null,
                    "rightcode": null,
                    "showdialog": null,
                    "pagePath": null,
                    "title": null,
                    "parentid": "F7A4549B82914D97AA334E6572F3F171",
                    "serialno": 5,
                    "righttype": "appright",
                    "library": null,
                    "createTime": null,
                    "enable": 1,
                    "entityName": "PcmRight",
                    "pageFile": null,
                    "rightid": "0d71871691a646cc9be69f229fb7ad61",
                    "hasSonMenu": 0,
                    "id": "0d71871691a646cc9be69f229fb7ad61",
                    "webiconcssclass": null,
                    "webpage": "/events",
                    "isPage": 0,
                    "name": "告警信息"
                  },
                  {
                    "next": [],
                    "rightname": "趋势分析",
                    "visible": 1,
                    "formclass": null,
                    "iconFile": "/daytrend.png;/",
                    "memo": null,
                    "rightcode": null,
                    "showdialog": null,
                    "pagePath": null,
                    "title": null,
                    "parentid": "F7A4549B82914D97AA334E6572F3F171",
                    "serialno": 6,
                    "righttype": "appright",
                    "library": null,
                    "createTime": null,
                    "enable": 1,
                    "entityName": "PcmRight",
                    "pageFile": null,
                    "rightid": "7f9a99b115ce44ff97471eed68025152",
                    "hasSonMenu": 0,
                    "id": "7f9a99b115ce44ff97471eed68025152",
                    "webiconcssclass": null,
                    "webpage": "/deviceTrend",
                    "isPage": 0,
                    "name": "趋势分析"
                  }
                ],
                "rightname": "网格",
                "visible": 1,
                "formclass": null,
                "iconFile": null,
                "memo": null,
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "97BF612A3A574FCAA64A8399398A0DBE",
                "serialno": 2,
                "righttype": "appright",
                "library": null,
                "createTime": null,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "f7a4549b82914d97aa334e6572f3f171",
                "hasSonMenu": 0,
                "id": "f7a4549b82914d97aa334e6572f3f171",
                "webiconcssclass": null,
                "webpage": "/moduleTablePower",
                "isPage": 0,
                "name": "网格"
              },
              {
                "next": [],
                "rightname": "最新事件",
                "visible": 1,
                "formclass": null,
                "iconFile": null,
                "memo": null,
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "97BF612A3A574FCAA64A8399398A0DBE",
                "serialno": 3,
                "righttype": "appright",
                "library": null,
                "createTime": null,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "b06555660cf448c59fe7ce72a2a5dd54",
                "hasSonMenu": 0,
                "id": "b06555660cf448c59fe7ce72a2a5dd54",
                "webiconcssclass": null,
                "webpage": "/newestIncident",
                "isPage": 0,
                "name": "最新事件"
              },
              {
                "next": [],
                "rightname": "最新通知",
                "visible": 1,
                "formclass": null,
                "iconFile": null,
                "memo": null,
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "97BF612A3A574FCAA64A8399398A0DBE",
                "serialno": 4,
                "righttype": "appright",
                "library": null,
                "createTime": null,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "e1e86b7241ad46528bf1c92db44938e2",
                "hasSonMenu": 0,
                "id": "e1e86b7241ad46528bf1c92db44938e2",
                "webiconcssclass": null,
                "webpage": "newest_inform",
                "isPage": 0,
                "name": "最新通知"
              }
            ],
            "rightname": "首页",
            "visible": 1,
            "formclass": null,
            "iconFile": "/menu_page_home.png;/menu_page_homeY.png",
            "memo": null,
            "rightcode": null,
            "showdialog": null,
            "pagePath": null,
            "title": null,
            "parentid": null,
            "serialno": 1,
            "righttype": "appright",
            "library": null,
            "createTime": null,
            "enable": 1,
            "entityName": "PcmRight",
            "pageFile": null,
            "rightid": "97bf612a3a574fcaa64a8399398a0dbe",
            "hasSonMenu": 0,
            "id": "97bf612a3a574fcaa64a8399398a0dbe",
            "webiconcssclass": null,
            "webpage": "/customizePage",
            "isPage": 0,
            "name": "首页"
          },
          {
            "next": [],
            "rightname": "抄表",
            "visible": 1,
            "formclass": null,
            "iconFile": "/menu_energy.png;/menu_energyY.png",
            "memo": null,
            "rightcode": null,
            "showdialog": null,
            "pagePath": null,
            "title": null,
            "parentid": null,
            "serialno": 2,
            "righttype": "appright",
            "library": null,
            "createTime": null,
            "enable": 1,
            "entityName": "PcmRight",
            "pageFile": null,
            "rightid": "1bace41c3b9a48adb58868be28c31cde",
            "hasSonMenu": 0,
            "id": "1bace41c3b9a48adb58868be28c31cde",
            "webiconcssclass": null,
            "webpage": "/myPowerMeter",
            "isPage": 0,
            "name": "抄表"
          },
          {
            "next": [],
            "rightname": "地图",
            "visible": 1,
            "formclass": null,
            "iconFile": "/menu_Map.png;/menu_MapY.png",
            "memo": null,
            "rightcode": null,
            "showdialog": null,
            "pagePath": null,
            "title": null,
            "parentid": null,
            "serialno": 3,
            "righttype": "appright",
            "library": null,
            "createTime": null,
            "enable": 1,
            "entityName": "PcmRight",
            "pageFile": null,
            "rightid": "ebfbcd332c714affa8687ef8e46e829a",
            "hasSonMenu": 0,
            "id": "ebfbcd332c714affa8687ef8e46e829a",
            "webiconcssclass": null,
            "webpage": "/appMap",
            "isPage": 0,
            "name": "地图"
          }];
        return d
      },
      miniRightList () {
        var data=[
          {
            "rightname": "首页",
            "name": "首页",
            "visible": 1,
            "formclass": null,
            "iconFile": "https://htm333.github.io/todous/src/img/images/m1.png",
            "memo": "小程序设备监测",
            "next": [
              {
                "next": [],
                "rightname": "设备监测",
                "visible": 1,
                "formclass": null,
                "iconFile": "https://htm333.github.io/todous/src/img/images/m1.png",
                "memo": "小程序设备监测",
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "f65cc2c1c2dc4c92b07e28c8362bd99c",
                "serialno": 101,
                "righttype": "miniright",
                "library": null,
                "createTime": 1675738184000,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "85633849b4b645adbc9f3aac6a0e78e3",
                "hasSonMenu": 0,
                "id": "85633849b4b645adbc9f3aac6a0e78e3",
                "webiconcssclass": null,
                "webpage": "detection",
                "isPage": null,
                "name": "设备监测"
              },
              {
                "next": [],
                "rightname": "设备档案",
                "visible": 1,
                "formclass": null,
                "iconFile": "https://htm333.github.io/todous/src/img/images/m2.png",
                "memo": "小程序设备档案",
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "f65cc2c1c2dc4c92b07e28c8362bd99c",
                "serialno": 102,
                "righttype": "miniright",
                "library": null,
                "createTime": 1675738213000,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "fa7ce472510845d799568b299b57a604",
                "hasSonMenu": 0,
                "id": "fa7ce472510845d799568b299b57a604",
                "webiconcssclass": null,
                "webpage": "equipmentArchives",
                "isPage": null,
                "name": "设备档案"
              },
              {
                "next": [],
                "rightname": "接线图",
                "visible": 1,
                "formclass": null,
                "iconFile": "https://htm333.github.io/todous/src/img/images/m3.png",
                "memo": "小程序接线图",
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "f65cc2c1c2dc4c92b07e28c8362bd99c",
                "serialno": 103,
                "righttype": "miniright",
                "library": null,
                "createTime": 1675738241000,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "467b75b9face4e4598ac7e74bd9ee24f",
                "hasSonMenu": 0,
                "id": "467b75b9face4e4598ac7e74bd9ee24f",
                "webiconcssclass": null,
                "webpage": "wiringDiagram",
                "isPage": null,
                "name": "接线图"
              },
              {
                "next": [],
                "rightname": "视频监控",
                "visible": 1,
                "formclass": null,
                "iconFile": "https://htm333.github.io/todous/src/img/images/m4.png",
                "memo": "小程序视频监控",
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "f65cc2c1c2dc4c92b07e28c8362bd99c",
                "serialno": 104,
                "righttype": "miniright",
                "library": null,
                "createTime": 1675738274000,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "75f6cddee6ae4ec493d7ef9647259518",
                "hasSonMenu": 0,
                "id": "75f6cddee6ae4ec493d7ef9647259518",
                "webiconcssclass": null,
                "webpage": "monitor",
                "isPage": null,
                "name": "视频监控"
              },
              {
                "next": [],
                "rightname": "用能统计",
                "visible": 1,
                "formclass": null,
                "iconFile": "https://htm333.github.io/todous/src/img/images/m5.png",
                "memo": "小程序用能统计",
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "f65cc2c1c2dc4c92b07e28c8362bd99c",
                "serialno": 105,
                "righttype": "miniright",
                "library": null,
                "createTime": 1675738303000,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "2a601f40e6994cc086aea345d62fecf3",
                "hasSonMenu": 0,
                "id": "2a601f40e6994cc086aea345d62fecf3",
                "webiconcssclass": null,
                "webpage": "statistics",
                "isPage": null,
                "name": "用能统计"
              },
              {
                "next": [],
                "rightname": "用能报表",
                "visible": 1,
                "formclass": null,
                "iconFile": "https://htm333.github.io/todous/src/img/images/m6.png",
                "memo": "小程序用能报表",
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "f65cc2c1c2dc4c92b07e28c8362bd99c",
                "serialno": 106,
                "righttype": "miniright",
                "library": null,
                "createTime": 1675738326000,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "7e9ece8186f54224ad0fcc47c482e8dd",
                "hasSonMenu": 0,
                "id": "7e9ece8186f54224ad0fcc47c482e8dd",
                "webiconcssclass": null,
                "webpage": "reportForm",
                "isPage": null,
                "name": "用能报表"
              },
              {
                "next": [],
                "rightname": "趋势分析",
                "visible": 1,
                "formclass": null,
                "iconFile": "https://htm333.github.io/todous/src/img/images/m7.png",
                "memo": "小程序趋势分析",
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "f65cc2c1c2dc4c92b07e28c8362bd99c",
                "serialno": 107,
                "righttype": "miniright",
                "library": null,
                "createTime": 1675738352000,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "229d93bb83844821ae76b61f9f6b95a7",
                "hasSonMenu": 0,
                "id": "229d93bb83844821ae76b61f9f6b95a7",
                "webiconcssclass": null,
                "webpage": "trendAnalysis",
                "isPage": null,
                "name": "趋势分析"
              },
              {
                "next": [],
                "rightname": "历史报表",
                "visible": 1,
                "formclass": null,
                "iconFile": "https://htm333.github.io/todous/src/img/images/m8.png",
                "memo": "小程序历史报表",
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "f65cc2c1c2dc4c92b07e28c8362bd99c",
                "serialno": 108,
                "righttype": "miniright",
                "library": null,
                "createTime": 1675738369000,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "39e4f5890d5848bfa1481fded92197f0",
                "hasSonMenu": 0,
                "id": "39e4f5890d5848bfa1481fded92197f0",
                "webiconcssclass": null,
                "webpage": "history",
                "isPage": null,
                "name": "历史报表"
              },
              {
                "next": [],
                "rightname": "月度报告",
                "visible": 1,
                "formclass": null,
                "iconFile": "https://htm333.github.io/todous/src/img/images/m9.png",
                "memo": "小程序月度报告",
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "f65cc2c1c2dc4c92b07e28c8362bd99c",
                "serialno": 109,
                "righttype": "miniright",
                "library": null,
                "createTime": 1675738402000,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "17d3f70ab1cd411aab03da0b3d2d7419",
                "hasSonMenu": 0,
                "id": "17d3f70ab1cd411aab03da0b3d2d7419",
                "webiconcssclass": null,
                "webpage": "monthlyReport",
                "isPage": null,
                "name": "月度报告"
              },
              {
                "next": [],
                "rightname": "电子档案",
                "visible": 1,
                "formclass": null,
                "iconFile": "https://htm333.github.io/todous/src/img/images/m10.png",
                "memo": "小程序电子档案",
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "f65cc2c1c2dc4c92b07e28c8362bd99c",
                "serialno": 110,
                "righttype": "miniright",
                "library": null,
                "createTime": 1675738482000,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "8c784f79c55d4b2f8c60abeece1589a3",
                "hasSonMenu": 0,
                "id": "8c784f79c55d4b2f8c60abeece1589a3",
                "webiconcssclass": null,
                "webpage": "electronic",
                "isPage": null,
                "name": "电子档案"
              },
              {
                "next": [],
                "rightname": "缺陷记录",
                "visible": 1,
                "formclass": null,
                "iconFile": "https://htm333.github.io/todous/src/img/images/m11.png",
                "memo": "小程序缺陷记录",
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "f65cc2c1c2dc4c92b07e28c8362bd99c",
                "serialno": 111,
                "righttype": "miniright",
                "library": null,
                "createTime": 1675738514000,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "7e2c6672ce614e98b745a3d22f3bc0f6",
                "hasSonMenu": 0,
                "id": "7e2c6672ce614e98b745a3d22f3bc0f6",
                "webiconcssclass": null,
                "webpage": "defectRecord",
                "isPage": null,
                "name": "缺陷记录"
              },
              {
                "next": [],
                "rightname": "抄表",
                "visible": 1,
                "formclass": null,
                "iconFile": "https://htm333.github.io/todous/src/img/images/m12.png",
                "memo": "小程序抄表",
                "rightcode": null,
                "showdialog": null,
                "pagePath": null,
                "title": null,
                "parentid": "f65cc2c1c2dc4c92b07e28c8362bd99c",
                "serialno": 112,
                "righttype": "miniright",
                "library": null,
                "createTime": 1675738544000,
                "enable": 1,
                "entityName": "PcmRight",
                "pageFile": null,
                "rightid": "82c2be02ec93415896d91a73b7edc8c0",
                "hasSonMenu": 0,
                "id": "82c2be02ec93415896d91a73b7edc8c0",
                "webiconcssclass": null,
                "webpage": "meterReading",
                "isPage": null,
                "name": "抄表"
              }]
          }];
        return data
      },


      // nowMenuCheckedIds() {
      // 	return userManagerStore.state.nowUserMenuRightIds
      // },
      // nowAppCheckedIds() {
      // 	return userManagerStore.state.nowUserAppRightIds
      // },
      nowMenuCheckedIds: {
        get: function() {
          return userManagerStore.state.nowUserMenuRightIds
        },
        set: function(newValue) {
          return userManagerStore.state.nowUserMenuRightIds=newValue
        }
      },
      nowAppCheckedIds: {
        get: function() {
          return userManagerStore.state.nowUserAppRightIds
        },
        set: function(newValue) {
          return userManagerStore.state.nowUserAppRightIds=newValue
        }
      },
      nowMiniCheckedIds: {
        get: function() {
          return userManagerStore.state.nowUserMiniRightIds
        },
        set: function(newValue) {
          return userManagerStore.state.nowUserMiniRightIds=newValue
        }
      },
      editDisableMenuList () {
        return userManagerStore.state.editDisableMenuList
      },
      editDisableAppList () {
        return userManagerStore.state.editDisableAppList
      },
      editDisableMiniList () {
        return userManagerStore.state.editDisableMiniList
      },
      userRolesRights () {
        return userManagerStore.state.nowUserRolesRights
      },
      a () {
        return "设备"
      },
      needSave () {
        var resultMenu=false
        var resultApp=false

        if(isempty(this.menuRightList)) {
          resultMenu=false
        } else {
          var menuRight=[]
          var menuKeys=Object.keys(this.$refs.menuSelection.nowSelectIds)
          for(let i=0;i<menuKeys.length;i++) {
            if(this.$refs.menuSelection.nowSelectIds[menuKeys[i]]) {
              menuRight.push(menuKeys[i])
            }
          }

          if(this.nowMenuCheckedIds.length==menuRight.length) {
            for(let i=0;i<menuRight.length;i++) {
              if(this.nowMenuCheckedIds.indexOf(menuRight[i])<0) {
                resultMenu=true
                break
              }
            }
          } else {
            resultMenu=true
          }
        }

        if(isempty(this.appRightList)) {
          resultApp=false
        } else {
          var appRight=[]
          var appKeys=Object.keys(this.$refs.appSelection.nowSelectIds)
          for(let i=0;i<appKeys.length;i++) {
            if(this.$refs.appSelection.nowSelectIds[appKeys[i]]) {
              appRight.push(appRight[i])
            }
          }
          if(this.nowAppCheckedIds.length==appRight.length) {
            for(let i=0;i<appRight.length;i++) {
              if(this.nowAppCheckedIds.indexOf(appRight[i])<0) {
                resultApp=true
                break
              }
            }
          } else {
            resultApp=true
          }
        }
        // console.log("resultMenu",!resultMenu);
        // console.log("resultApp",!resultApp);
        if(!resultMenu&&!resultApp) {
          return false
        } else {
          return true
        }
      }
    },
    watch: {
      nowMenuCheckedIds (nv,ov) {
        this.resetDatas()
      }
    },
    methods: {
      recursiveFunction_fn (data) {
        if(data!=undefined) {


          var arr=[]
          var recursiveFunction=function() {
            const getStr=function(list) {
              list.forEach(function(row) {
                if(row.next.length!=0) {
                  // console.log("row.ChildDatas",row);
                  arr.push(row)
                  getStr(row.next)
                } else {
                  // console.log("row.ChildDatas1234",row);
                  // str += row.Content.Name + ";"
                  arr.push(row)
                }
              })
            }
            getStr(data)
          }
          recursiveFunction()
          return arr
        }
      },
      resetDatas () {
        this.$refs.menuSelection.setNowCheckedIds(this.nowMenuCheckedIds)
        this.$refs.appSelection.setNowCheckedIds(this.nowAppCheckedIds)
        this.$refs.miniSelection.setNowCheckedIds(this.nowMiniCheckedIds)
        this.$refs.menuSelection.setEditDisableList(this.editDisableMenuList)
        this.$refs.appSelection.setEditDisableList(this.editDisableAppList)
        this.$refs.miniSelection.setEditDisableList(this.editDisableMiniList)
      },
      saveEdit () {
        // if(!this.needSave){
        // 	return
        // }
        var menuRight=[]
        var menuKeys=Object.keys(this.$refs.menuSelection.nowSelectIds)
        for(let i=0;i<menuKeys.length;i++) {
          if(this.$refs.menuSelection.nowSelectIds[menuKeys[i]]) {
            menuRight.push(menuKeys[i])
          }
        }
        var appRight=[]
        var appKeys=Object.keys(this.$refs.appSelection.nowSelectIds)
        for(let i=0;i<appKeys.length;i++) {
          if(this.$refs.appSelection.nowSelectIds[appKeys[i]]) {
            appRight.push(appRight[i])
          }
        }

        var miniRight=[]
        var miniKeys=Object.keys(this.$refs.miniSelection.nowSelectIds)
        for(let i=0;i<miniKeys.length;i++) {
          if(this.$refs.miniSelection.nowSelectIds[miniKeys[i]]) {
            miniRight.push(miniKeys[i])
          }
        }
        var rightArr=menuRight.concat(appRight,miniRight)
        var rightIds=rightArr.join(',')
        this.$api.userApi.bindUserAndRight(this.user.id,rightIds,res => {
          this.$dialogMethod.showMessage(res)
          this.$store.menuStore.commit("getMenuList")
          this.resetCheckedIds()
        },failure => {
          this.$dialogMethod.showMessage(failure)
        })
      },
      resetCheckedIds () {
        var webRight=[]
        var menuKeys=Object.keys(this.$refs.menuSelection.nowSelectIds)
        for(let i=0;i<menuKeys.length;i++) {
          if(this.$refs.menuSelection.nowSelectIds[menuKeys[i]]) {
            webRight.push(menuKeys[i])
          }
        }
        var appRight=[]
        var appKeys=Object.keys(this.$refs.appSelection.nowSelectIds)
        for(let i=0;i<appKeys.length;i++) {
          if(this.$refs.appSelection.nowSelectIds[appKeys[i]]) {
            appRight.push(appKeys[i])
          }
        }

        var miniRight=[]
        var miniKeys=Object.keys(this.$refs.miniSelection.nowSelectIds)
        for(let i=0;i<miniKeys.length;i++) {
          if(this.$refs.miniSelection.nowSelectIds[miniKeys[i]]) {
            miniRight.push(miniKeys[i])
          }
        }
        this.nowMenuCheckedIds=webRight
        this.nowAppCheckedIds=appRight
        this.nowMiniCheckedIds=miniRight
      },
      coverCheckedIds () {
        this.$refs.menuSelection.setNowCheckedIds(this.nowMenuCheckedIds)
        this.$refs.appSelection.setNowCheckedIds(this.nowAppCheckedIds)
        this.$refs.miniSelection.setNowCheckedIds(this.nowMiniCheckedIds)
      }
    }
  }
</script>

<style>
  .jurisdictionItem {
    border: solid 1px #E4E4E4;
    height: 92%;
    /* border: 0px !important; */
    box-sizing: border-box;
    float: left;
    margin-right: 30px;
    width: calc(32% - 15px) !important;
  }

  .jurisdictionItem:last-child {
    margin-right: 0;
  }

  .jurisdictionItem .list-body {
    border: none;
  }

  .jurisdictionTitle {
    font-size: 14px;
    color: #999999;
    line-height: 20px;
    /* background: #E3E7EC; */
    /* text-align: center; */
    background-color: #F3F8FF !important;
    line-height: 44px;
    padding-left: 12px;
    font-weight: bold;

  }
</style>